import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { SectionHead } from "../components/Motion";
import { toast } from "sonner";

export default function Corporate() {
  const [form, setForm] = useState({ company: "", contact_person: "", email: "", phone: "", quantity: "", budget_per_gift: "", delivery_location: "", requirements: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/corporate", form);
      toast.success(data.message);
      setForm({ company: "", contact_person: "", email: "", phone: "", quantity: "", budget_per_gift: "", delivery_location: "", requirements: "" });
    } catch (err) {
      toast.error(formatApiError(err));
    }
    setLoading(false);
  };

  const input = "mt-1.5 w-full bg-[#FBF7F1] border border-[#7E1E3F]/25 rounded-xl px-4 py-3 text-sm text-[#2E1A22] outline-none focus:border-[#7E1E3F]/60 placeholder:text-[#857078]";
  const F = ({ label, testid, ...props }) => (
    <label><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">{label}</span>
      <input {...props} className={input} data-testid={testid} /></label>
  );

  return (
    <div className="pt-28 pb-24 max-w-3xl mx-auto px-4 sm:px-6 min-h-screen" data-testid="corporate-page">
      <SectionHead overline="Corporate Gifting" title="Corporate Gifting"
        sub="Thoughtful gifting for clients, teams and special business occasions. Bulk pricing, branded sleeves and reliable delivery — tell us what you need."
        center testid="corporate-head" />
      <form onSubmit={submit} className="card-surface rounded-2xl p-6 sm:p-8 grid sm:grid-cols-2 gap-5" data-testid="corporate-form">
        <F label="Company Name" required value={form.company} onChange={(e) => setForm({ ...form, company: e.target.value })} testid="corp-company" />
        <F label="Contact Person" value={form.contact_person} onChange={(e) => setForm({ ...form, contact_person: e.target.value })} testid="corp-contact" />
        <F label="Email" required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} testid="corp-email" />
        <F label="Phone" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} testid="corp-phone" />
        <F label="Quantity" placeholder="e.g. 100" value={form.quantity} onChange={(e) => setForm({ ...form, quantity: e.target.value })} testid="corp-quantity" />
        <F label="Budget per Gift" placeholder="e.g. ₹1,500" value={form.budget_per_gift} onChange={(e) => setForm({ ...form, budget_per_gift: e.target.value })} testid="corp-budget" />
        <F label="Delivery Location" value={form.delivery_location} onChange={(e) => setForm({ ...form, delivery_location: e.target.value })} testid="corp-location" />
        <F label="Festival / Occasion" value={form.occasion || ""} onChange={(e) => setForm({ ...form, occasion: e.target.value })} testid="corp-occasion" />
        <label className="sm:col-span-2"><span className="text-xs font-mono-lux tracking-[0.15em] uppercase text-[#857078]">Requirements</span>
          <textarea rows={4} className={input} value={form.requirements} onChange={(e) => setForm({ ...form, requirements: e.target.value })} data-testid="corp-requirements" /></label>
        <div className="sm:col-span-2 text-center">
          <button disabled={loading} className="bg-[#7E1E3F] text-[#FFFFFF] font-semibold text-sm tracking-wider uppercase rounded-full px-10 py-4 hover:bg-[#5C1230] transition-colors disabled:opacity-60" data-testid="corp-submit">
            {loading ? "Sending…" : "Request a Quote"}
          </button>
        </div>
      </form>
    </div>
  );
}
